<script lang="ts">
	import { getBgColorClassName } from '@app/theme/colors';
	import { SVG } from '@wiseed/wikit';
	import { viewport } from '@wiseed/wikit';
	import { OperationCategoryEnum } from '@app/models/api/enums/OperationCategoryEnum';

	export let category: string;
	$: category = category.toLowerCase().replaceAll('_', '-');
</script>

<div
	class={`rounded-full ${getBgColorClassName(
		category
	)} p-2 md:p-3 border border-white border-8 text-white`}
>
	<SVG
		name={category}
		size={$viewport.isDesktop ? 'big' : 'default'}
		classNames={category ===
		OperationCategoryEnum.TECH_AND_INNOVATION.toLowerCase().replaceAll('_', '-')
			? 'fill-none stroke-current'
			: 'false'}
	/>
</div>
